import React, {useState} from "react";
import "./style.scss";
import {
    SettingsLanguageIcon,
    SettingsOptionSelectedIcon,
    SettingsPlaybackRateIcon,
    SettingsQualityIcon,
    SettingsReturnArrowIcon
} from "../../Icons";
import {useLocaleContext} from "../../../../context/LocaleContext";
import useClickOutside from "../../../../../../cp/hooks/useClickOutside";

export const TYPE_ALL = 'all';
export const TYPE_PLAYBACK_RATE = 'playbackRate';
export const TYPE_QUALITY = 'quality';
export const TYPE_LANGUAGE = 'language';

export const SettingsSelectOptions = ({title, options, value, onSelect, onClose, onReturn}) => {
    const className = 'player-settings-select';
    const handleSelect = (option) => {
        onSelect(option.value);
        onClose();
    }

    return (
        <div className={className}>
            <div onClick={onReturn} className={`${className}-title`}>
                <div>
                    {onReturn ? <SettingsReturnArrowIcon /> : <div>&nbsp;</div>}
                    <div>{title}</div>
                </div>
            </div>
            <hr />
            <div>
                {options.map((option) => (
                    <div key={option.value} onClick={() => handleSelect(option)} className={(option.value === value ? ' active': '')}>
                        <div className={"option-icon"}>
                            {option.value === value && <SettingsOptionSelectedIcon isSmall /> }
                        </div>
                        <div>
                            {option.label}
                            {option.sup && <sup> {option.sup}</sup>}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export const SettingsButton = ({title, value, options, onChange, children}) => {
    const [visible, setVisible] = useState(false);

    const toggleVisible = () => {
        if (options.length > 1) {
            setVisible(!visible);
        }
    }
    const handleClose = () => setVisible(false);

    const ref = useClickOutside(handleClose);

    return (
        <div ref={ref} className={`player-controls-settings-button player-controls-desktop`}>
            <a onClick={toggleVisible}>{children}</a>
            {visible && (
                <div className={`player-controls-settings-button-overlay`}>
                    <SettingsSelectOptions
                        title={title}
                        value={value}
                        options={options}
                        onSelect={onChange}
                        onClose={handleClose}
                    />
                </div>
            )}
        </div>
    );
}

const SettingsType = ({icon, value, onClick, children}) => {
    const className = 'player-settings-types-type';
    return (
        <div className={className} onClick={onClick}>
            <div className={`${className}-icon`}>{icon ? icon : null}</div>
            <div className={`${className}-title`}>{children}</div>
            <div className={`${className}-value`}>{value}</div>
            <div className={`${className}-arrow`}>&gt;</div>
        </div>
    );
}

export const SettingsGlobalButton = (
    {
        playbackRates, playbackRate, onChangePlaybackRate,
        qualities, quality, onChangeQuality,
        languages, language, onChangeLanguage,
        children,
    }
) => {
    const {get: getLocale} = useLocaleContext();
    const [visible, setVisible] = useState(null);

    const toggleVisible = () => setVisible(visible === null ? TYPE_ALL : null);
    const handleClose = () => setVisible(null);
    const handleReturn = () => setVisible(TYPE_ALL);

    const ref = useClickOutside(handleClose);

    return (
        <div ref={ref} className={`player-controls-settings-button player-controls-tablet`}>            
            {visible === TYPE_PLAYBACK_RATE && (
                <div className={`player-controls-settings-button-overlay`}>
                    <SettingsSelectOptions
                        title={getLocale('broadcast.player.playbackRate.label')}
                        options={playbackRates}
                        value={playbackRate}
                        onSelect={(value) => onChangePlaybackRate(value)}
                        onClose={handleClose}
                        onReturn={handleReturn}
                    />
                </div>
            )}
            {visible === TYPE_LANGUAGE && (
                <div className={`player-controls-settings-button-overlay`}>
                    <SettingsSelectOptions
                        title={getLocale('broadcast.player.language.label')}
                        options={languages}
                        value={language.channel}
                        onSelect={(value) => onChangeLanguage(value)}
                        onClose={handleClose}
                        onReturn={handleReturn}
                    />
                </div>
            )}
            {visible === TYPE_QUALITY && (
                <div className={`player-controls-settings-button-overlay`}>
                    <SettingsSelectOptions
                        title={getLocale('broadcast.player.quality.label')}
                        options={qualities}
                        value={quality?.number}
                        onSelect={(value) => onChangeQuality(value)}
                        onClose={handleClose}
                        onReturn={handleReturn}
                    />
                </div>
            )}
            {visible === TYPE_ALL && (
                <div className={`player-controls-settings-button-overlay`}>
                    <div className={`player-settings-types`}>
                        {playbackRates?.length > 1 && (
                            <SettingsType
                                onClick={() => setVisible(TYPE_PLAYBACK_RATE)}
                                value={playbackRate}
                                icon={<SettingsPlaybackRateIcon />}
                            >{getLocale('broadcast.player.playbackRate.label')}</SettingsType>
                        )}
                        {languages?.length > 1 && (
                            <SettingsType
                                onClick={() => setVisible(TYPE_LANGUAGE)}
                                value={language.description}
                                icon={<SettingsLanguageIcon />}
                            >{getLocale('broadcast.player.language.label')}</SettingsType>
                        )}
                        {qualities?.length > 1 && (
                            <SettingsType
                                onClick={() => setVisible(TYPE_QUALITY)}
                                value={quality.label}
                                icon={<SettingsQualityIcon />}
                            >{getLocale('broadcast.player.quality.label')}</SettingsType>
                        )}
                    </div>
                </div>
            )}
            <a onClick={toggleVisible}>{children}</a>
        </div>
    );
}
